import type { ComponentType } from 'react';
import { CustomerDashboardPage } from './CustomerDashboardPage';
import { ExchangeDashboardPage } from './ExchangeDashboardPage';

/**
 * PANEL EKRANININ KAYDI.
 *
 * Router'a DOKUNULMAZ: `src/app/screens.ts` bu sabiti icine alir
 * (`...dashboardScreens`). Boylece feature'i hayata gecirmek rota agacini
 * degistirmeden mumkun oluyor ve birbirinden bagimsiz feature'lar tek bir
 * dosyada catismiyor.
 *
 * Anahtar `src/layout/menus.ts` icindeki MENU KIMLIGI. Yeni bir kimlik
 * uydurulamaz: menude olmayan bir kimlik hicbir zaman cizilmez. Rotanin
 * `viewReport` kapisi da menu verisinden geliyor (router.tsx `withItemGuard`).
 */
export const dashboardScreens = {
  'exchange.dashboard': ExchangeDashboardPage,
  // Musteri panelinde `viewReport` kapisi YOK (menude de yok): burasi rapor degil,
  // kullanicinin KENDI verisi. Yonetici bolumlerini ekranin kendisi ekliyor ve
  // sunucu ayrica requireOrgAdmin ile koruyor.
  'customer.dashboard': CustomerDashboardPage,
} as const satisfies Readonly<Record<string, ComponentType>>;
